import Firebase from "../images/firebase.svg";
import MUI from "../images/mui.png";
import OpenAI from "../images/openai.png";
import ReactNative from "../images/reactnative.png";
import Python from "../images/python.png";
import Pyqt5 from "../images/pyqt5.png";
import ReactLogo from "../images/react.png";
import SQL from "../images/sql.png";
import Tailwind from "../images/tailwind.png";
import Typescript from "../images/typescript.png";
import Java from "../images/java.webp";
import Figma from "../images/figma.png";
import Copilot from "../images/copilot.png";
import Photoshop from "../images/photoshop.png";
import VisualStudio from "../images/vscode.png";
import Git from "../images/git.png";
import Hibernate from "../images/hibernate.png";
import HTMLImage from "../images/html.png";
import CSSImage from "../images/css.png";
import Node from "../images/node.svg";
import Express from "../images/express.png";
import Mongo from "../images/mongo.svg";
import Sharepoint from "../images/sharepoint.png";
import Javascript from "../images/javascript.png";
import Redux from "../images/redux.svg";
import Docker from "../images/docker.png";
import Next from "../images/next.svg";

export const languages = [
  {
    name: "Javascript",
    image: Javascript,
  },
  {
    name: "Typescript",
    image: Typescript,
  },

  {
    name: "Python",
    image: Python,
  },
  {
    name: "Java",
    image: Java,
  },
];

export const frontend = [
  {
    name: "React",
    image: ReactLogo,
  },

  {
    name: "Next",
    image: Next,
  },
  {
    name: "Tailwind",
    image: Tailwind,
  },
  {
    name: "HTML5",
    image: HTMLImage,
  },
  {
    name: "CSS3",
    image: CSSImage,
  },
  {
    name: "React Native",
    image: ReactNative,
  },

  {
    name: "Redux",
    image: Redux,
  },
  {
    name: "Material UI",
    image: MUI,
  },
  {
    name: "Pyqt5",
    image: Pyqt5,
  },
];

export const backend = [
  {
    name: "Node",
    image: Node,
  },
  {
    name: "Express",
    image: Express,
  },
  {
    name: "Docker",
    image: Docker,
  },
  {
    name: "Firebase",
    image: Firebase,
  },
  {
    name: "SQL",
    image: SQL,
  },
  {
    name: "MongoDB",
    image: Mongo,
  },
  {
    name: "Hibernate",
    image: Hibernate,
  },
  {
    name: "Sharepoint",
    image: Sharepoint,
  },
];

export const tools = [
  {
    name: "Git",
    image: Git,
  },
  {
    name: "OpenAI",
    image: OpenAI,
  },
  {
    name: "VS Code",
    image: VisualStudio,
  },
  {
    name: "Photoshop",
    image: Photoshop,
  },
  {
    name: "Figma",
    image: Figma,
  },
  {
    name: "Copilot",
    image: Copilot,
  },
];
